import React, { ChangeEvent, useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
    Button,
    CardMedia,
    IconButton,
    Input,
    MenuItem,
    Select,
    SelectChangeEvent,
    TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const EditProgram = () => {
    const navigate = useNavigate();
    const location = useLocation();

    // Get program data from navigation state
    const programData = (location.state && location.state.program) || {};

    const [image, setImage] = useState<string>(programData.thumbnail || "");
    const [fileName, setFileName] = useState<string>("");

    const [title, setTitle] = useState<string>(programData.title || "");
    const [duration, setDuration] = useState<string>(programData.duration || "");
    const [difficulty, setDifficulty] = useState<string>(programData.difficulty || "default");
    const [description, setDescription] = useState<string>(programData.description || "");
    const [goals, setGoals] = useState<string>(programData.goals || "");
    const [equipment, setEquipment] = useState<string>(programData.equipment || "");

    const handleDifficulty = (event: SelectChangeEvent) => {
        setDifficulty(event.target.value as string);
    };

    return (
        <>
            <div className="main_title">
                <h1>Edit Program</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
                    <button onClick={() => navigate("/manage-programs")}>
                        Manage Programs
                    </button>{" "}
                    - Edit Program
                </p>
            </div>

            <div className="cards">
                <div className="form">
                    <div className="gap_p">

                        {/* Program Thumbnail */}
                        <div className="control_group w_33">
                            <label htmlFor="icon-button-file">Program Thumbnail*</label>
                            {image ? (
                                <div className="upload_image">
                                    <div className="upload_image_holder">
                                        <figure>
                                            <CardMedia
                                                component="img"
                                                image={image}
                                                alt="Uploaded Thumbnail"
                                            />
                                        </figure>
                                        <IconButton
                                            aria-label="Remove uploaded image"
                                            onClick={() => {
                                                setImage("");
                                                setFileName("");
                                            }}
                                            size="small"
                                        >
                                            <CloseIcon />
                                        </IconButton>
                                    </div>
                                </div>
                            ) : (
                                <label className="upload_image" htmlFor="icon-button-file">
                                    <Input
                                        sx={{ display: "none" }}
                                        id="icon-button-file"
                                        type="file"
                                        inputProps={{ accept: "image/png,image/jpeg" }}
                                        onChange={(e: ChangeEvent<HTMLInputElement>) => {
                                            const files = e.target.files;
                                            if (files && files[0].type.includes("image")) {
                                                setFileName(files[0].name);
                                                setImage(URL.createObjectURL(files[0]));
                                            }
                                        }}
                                    />
                                    <span className="upload_image_holder">
                                        <figure className="add_img">
                                            <img
                                                src="/static/images/user_placeholder.png"
                                                alt="placeholder"
                                                style={{ objectFit: "contain" }}
                                            />
                                            <span className="upload_img_icon">
                                                <img src="/static/images/edit2_icon.svg" alt="Upload" />
                                            </span>
                                        </figure>
                                    </span>
                                </label>
                            )}
                        </div>

                        {/* Program Title */}
                        <div className="control_group w_33">
                            <label>Program Title*</label>
                            <TextField
                                placeholder="Enter Program Title"
                                fullWidth
                                value={title}
                                onChange={(e) => setTitle(e.target.value)}
                            />
                        </div>

                        {/* Duration */}
                        <div className="control_group w_33">
                            <label>Duration*</label>
                            <TextField
                                placeholder="12 Weeks / 6 Weeks"
                                fullWidth
                                value={duration}
                                onChange={(e) => setDuration(e.target.value)}
                            />
                        </div>

                        {/* Difficulty */}
                        <div className="control_group w_33">
                            <label>Difficulty*</label>
                            <Select fullWidth value={difficulty} onChange={handleDifficulty}>
                                <MenuItem disabled value="default">Select Difficulty</MenuItem>
                                <MenuItem value="Beginner">Beginner</MenuItem>
                                <MenuItem value="Intermediate">Intermediate</MenuItem>
                                <MenuItem value="Advanced">Advanced</MenuItem>
                            </Select>
                        </div>

                        {/* Description */}
                        <div className="control_group w_100">
                            <label>Description*</label>
                            <TextField
                                placeholder="Enter Program Description"
                                fullWidth
                                multiline
                                rows={3}
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                            />
                        </div>

                        {/* Goals */}
                        <div className="control_group w_100">
                            <label>Goals*</label>
                            <TextField
                                placeholder="Strength, Fat Loss, Endurance..."
                                fullWidth
                                multiline
                                rows={2}
                                value={goals}
                                onChange={(e) => setGoals(e.target.value)}
                            />
                        </div>

                        {/* Equipment Needed */}
                        <div className="control_group w_100">
                            <label>Equipment Needed*</label>
                            <TextField
                                placeholder="Dumbbells, Mat, None..."
                                fullWidth
                                value={equipment}
                                onChange={(e) => setEquipment(e.target.value)}
                            />
                        </div>

                    </div>

                    {/* Save Button */}
                    <div className="form_btn">
                        <Button className="btn btn_primary">Save Changes</Button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default EditProgram;
